import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AppEffects } from './app.effects';
import { reducer, initialState } from './app.reducer';
import { AppState } from './app.state';
import { GUIDED_TOUR_ENGINE } from '../../features/guided-tour/models/guided-tour-engine';
import { IntroJsTourEngine } from '../../features/guided-tour/services/intro-js-tour-engine.service';
import { GuidedTourEffects } from '../../features/guided-tour/store/guided-tour.effects';
import { getEnvironment } from '../../features/shared/utils/get-environment';
import { createLocalStorageSyncReducer } from '../local-storage-sync';

const syncMetaReducer = createLocalStorageSyncReducer<AppState>({
  keys: ['sidenavExtended'],
  rehydrate: true,
  storage: sessionStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('app', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([AppEffects, GuidedTourEffects]),
  ],
  providers: [AppEffects, GuidedTourEffects, { provide: GUIDED_TOUR_ENGINE, useExisting: IntroJsTourEngine }],
})
export class AppStoreModule {}
